module.exports = __webpack_public_path__ + "static/media/ios-power.fe603090.svg";